import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import * as _ from "lodash";

import { LoadingBarService } from "@ngx-loading-bar/core";

import { HeaderService, SupervisorService } from "../../../shared";

@Component({
  selector: "app-supervisor-list",
  templateUrl: "./supervisor-list.component.html",
  styleUrls: ["./supervisor-list.component.scss"]
})
export class SupervisorListComponent implements OnInit {
  typeComponent = "supervisor";

  textBtnNew = "Novo Supervisor";
  urlBtnNew = "/panel/supervisor/new";

  currentUrl = "/panel/supervisor";

  dataList;

  pag;
  filters;
  cacheObj;

  supervisorRequest;

  totalSupervisor;
  totalServices;

  constructor(
    private headerService: HeaderService,
    private supervisorService: SupervisorService,
    private loadingBarService: LoadingBarService,
    private activatedRoute: ActivatedRoute
  ) {
    if (this.activatedRoute.snapshot.params.pag) {
      this.pag = this.activatedRoute.snapshot.params.pag;
    } else {
      this.pag = 1;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle("Supervisores");

    this.headerService.changeSubtitle("");

    this.headerService.changeDatePicker(false);

    this.dataList = {};

    this.translateFilter();
  }

  supervisorList(filters = "") {
    this.loadingBarService.stop();

    this.loadingBarService.start();

    if (this.supervisorRequest) {
      this.supervisorRequest.unsubscribe();
    }

    this.supervisorRequest = this.supervisorService
      .listSupervisors(filters)
      .subscribe(response => {
        this.loadingBarService.complete();

        this.dataList = response;

        this.totalServices = response["total"];
      });
  }

  setPag(setPag) {
    this.pag = setPag;

    this.translateFilter();
  }

  translateFilter(obj?) {
    this.filters = [];

    if (obj) {
      this.cacheObj = obj;
    }

    _.forOwn(this.cacheObj, (value, key) => {
      this.filters.push(`${key}=${value}`);
    });

    this.supervisorList(`?pageNumber=${this.pag}&` + this.filters.join("&"));
  }
}
